import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/features/store';

/**
 * Получить состояние слайса автомобилей
 */
const carsSelector = createSelector(
  (state: RootState) => state.cars,
  cars => cars,
);

export default carsSelector;
